/* tslint:disable */
import { Injectable } from '@angular/core';
import { OpenErpService } from '../../models/OpenErpService';
import { OpenErpUser } from '../../models/OpenErpUser';
import { Role } from '../../models/Role';
import { Partner } from '../../models/Partner';
import { PartnerAddress } from '../../models/PartnerAddress';
import { PartnerContact } from '../../models/PartnerContact';
import { Product } from '../../models/Product';
import { ProductCategory } from '../../models/ProductCategory';
import { ProductCategoryType } from '../../models/ProductCategoryType';
import { ProductUom } from '../../models/ProductUom';
import { ProductUomCategory } from '../../models/ProductUomCategory';
import { PurchaseOrder } from '../../models/PurchaseOrder';
import { PurchaseOrderLine } from '../../models/PurchaseOrderLine';
import { PurchaseRequisition } from '../../models/PurchaseRequisition';
import { PurchaseRequisitionLine } from '../../models/PurchaseRequisitionLine';
import { CrmClaim } from '../../models/CrmClaim';
import { CrmCaseStage } from '../../models/CrmCaseStage';
import { Company } from '../../models/Company';
import { StockPicking } from '../../models/StockPicking';
import { StockQuantPackage } from '../../models/StockQuantPackage';
import { MoveQualityControl } from '../../models/MoveQualityControl';
import { QualityMeasureValue } from '../../models/QualityMeasureValue';
import { QualityMeasure } from '../../models/QualityMeasure';
import { StockMove } from '../../models/StockMove';
import { StockPickingLine } from '../../models/StockPickingLine';
import { StockLocation } from '../../models/StockLocation';
import { StockWarehouseLocation } from '../../models/StockWarehouseLocation';
import { StockWarehouse } from '../../models/StockWarehouse';
import { DeliveryCarrier } from '../../models/DeliveryCarrier';
import { ClaimLine } from '../../models/ClaimLine';
import { Users } from '../../models/Users';
import { Groups } from '../../models/Groups';
import { ProductImages } from '../../models/ProductImages';
import { GpsPosition } from '../../models/GpsPosition';
import { ModuleCategory } from '../../models/ModuleCategory';
import { ImageGallery } from '../../models/ImageGallery';
import { PartnerLerProduct } from '../../models/PartnerLerProduct';
import { ConfigParameter } from '../../models/ConfigParameter';
import { ResiduePartnerKPI } from '../../models/ResiduePartnerKPI';
import { ResiduePartnerKpiType } from '../../models/ResiduePartnerKpiType';
import { StockProductionLot } from '../../models/StockProductionLot';
import { StockQuant } from '../../models/StockQuant';
import { Autologin } from '../../models/Autologin';
import { LerOperatorType } from '../../models/LerOperatorType';
import { LerOperationType } from '../../models/LerOperationType';
import { FilterSizeAnalysis } from '../../models/FilterSizeAnalysis';
import { FilterValuesQualityAnalysis } from '../../models/FilterValuesQualityAnalysis';
import { HomogenizationOrder } from '../../models/HomogenizationOrder';
import { HomogenizationOrderInLine } from '../../models/HomogenizationOrderInLine';
import { HomogenizationOrderLine } from '../../models/HomogenizationOrderLine';
import { HomogenizationOrderOutLine } from '../../models/HomogenizationOrderOutLine';
import { LotConfigurationMpoLine } from '../../models/LotConfigurationMpoLine';
import { LotQualityAnalysis } from '../../models/LotQualityAnalysis';
import { LotQualityAnalysisImage } from '../../models/LotQualityAnalysisImage';
import { ManufacturingProductionOrder } from '../../models/ManufacturingProductionOrder';
import { ManufacturingProductionOrderLine } from '../../models/ManufacturingProductionOrderLine';
import { ManufacturingWorkLine } from '../../models/ManufacturingWorkLine';
import { ManufacturingWorkShift } from '../../models/ManufacturingWorkShift';
import { ProductionOrder } from '../../models/ProductionOrder';
import { ProductionOrderInLine } from '../../models/ProductionOrderInLine';
import { ProductionOrderLine } from '../../models/ProductionOrderLine';
import { ProductionOrderOutLine } from '../../models/ProductionOrderOutLine';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    OpenErpService: OpenErpService,
    OpenErpUser: OpenErpUser,
    Role: Role,
    Partner: Partner,
    PartnerAddress: PartnerAddress,
    PartnerContact: PartnerContact,
    Product: Product,
    ProductCategory: ProductCategory,
    ProductCategoryType: ProductCategoryType,
    ProductUom: ProductUom,
    ProductUomCategory: ProductUomCategory,
    PurchaseOrder: PurchaseOrder,
    PurchaseOrderLine: PurchaseOrderLine,
    PurchaseRequisition: PurchaseRequisition,
    PurchaseRequisitionLine: PurchaseRequisitionLine,
    CrmClaim: CrmClaim,
    CrmCaseStage: CrmCaseStage,
    Company: Company,
    StockPicking: StockPicking,
    StockQuantPackage: StockQuantPackage,
    MoveQualityControl: MoveQualityControl,
    QualityMeasureValue: QualityMeasureValue,
    QualityMeasure: QualityMeasure,
    StockMove: StockMove,
    StockPickingLine: StockPickingLine,
    StockLocation: StockLocation,
    StockWarehouseLocation: StockWarehouseLocation,
    StockWarehouse: StockWarehouse,
    DeliveryCarrier: DeliveryCarrier,
    ClaimLine: ClaimLine,
    Users: Users,
    Groups: Groups,
    ProductImages: ProductImages,
    GpsPosition: GpsPosition,
    ModuleCategory: ModuleCategory,
    ImageGallery: ImageGallery,
    PartnerLerProduct: PartnerLerProduct,
    ConfigParameter: ConfigParameter,
    ResiduePartnerKPI: ResiduePartnerKPI,
    ResiduePartnerKpiType: ResiduePartnerKpiType,
    StockProductionLot: StockProductionLot,
    StockQuant: StockQuant,
    Autologin: Autologin,
    LerOperatorType: LerOperatorType,
    LerOperationType: LerOperationType,
    FilterSizeAnalysis: FilterSizeAnalysis,
    FilterValuesQualityAnalysis: FilterValuesQualityAnalysis,
    HomogenizationOrder: HomogenizationOrder,
    HomogenizationOrderInLine: HomogenizationOrderInLine,
    HomogenizationOrderLine: HomogenizationOrderLine,
    HomogenizationOrderOutLine: HomogenizationOrderOutLine,
    LotConfigurationMpoLine: LotConfigurationMpoLine,
    LotQualityAnalysis: LotQualityAnalysis,
    LotQualityAnalysisImage: LotQualityAnalysisImage,
    ManufacturingProductionOrder: ManufacturingProductionOrder,
    ManufacturingProductionOrderLine: ManufacturingProductionOrderLine,
    ManufacturingWorkLine: ManufacturingWorkLine,
    ManufacturingWorkShift: ManufacturingWorkShift,
    ProductionOrder: ProductionOrder,
    ProductionOrderInLine: ProductionOrderInLine,
    ProductionOrderLine: ProductionOrderLine,
    ProductionOrderOutLine: ProductionOrderOutLine,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// ./src/sdk/services/custom/SDKModels.ts